// removed by extract-text-webpack-plugin
module.exports = {"school-information-form-wrapper":"school-information-form-wrapper","title-section":"title-section","form-field":"form-field","form-group":"form-group","field-object":"field-object","submit-field":"submit-field","form-control":"form-control"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/SchoolInformation/SchoolInformationForm.scss
// module id = 1rEC
// module chunks = 0